import { ActionCreator } from 'redux';
import navigationActionTypes, { INavigationPayload } from './types';
import { IAction } from 'coral-utility';

export const getNavigationAction: ActionCreator<IAction> = () => ({
  type: navigationActionTypes.GET_NAVIGATION_ITEMS,
});

export const getNavigationSuccessAction: ActionCreator<IAction> = (items: INavigationPayload) => ({
  type: navigationActionTypes.GET_NAVIGATION_ITEMS_SUCCESS,
  payload: { items },
});

export const getNavigationFailureAction: ActionCreator<IAction> = () => ({
  type: navigationActionTypes.GET_NAVIGATION_ITEMS_FAILURE,
});
